import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SanitizedHtml } from "@/components/common/sanitized-html";
import { recipientMeta } from "@/features/settings/components/tabs/letter-template-card";
import type { LetterTemplate } from "@/features/letters/types";
import { cn } from "@/lib/utils";

interface Props {
  template: LetterTemplate | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Read-only preview of a letter template — its subject and body HTML on screen
 * (no PDF render, no API call). Merge-field placeholders show as-is since there's
 * no client bound at the settings level.
 */
export function LetterPreviewDialog({ template, open, onOpenChange }: Props) {
  if (!template) return null;
  const meta = recipientMeta(template.recipient);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2.5">
            {template.name}
            <span
              className={cn(
                "rounded-full px-2 py-[3px] text-[11px] font-bold tracking-[0.06em] uppercase",
                meta.pill,
              )}
            >
              {meta.label}
            </span>
          </DialogTitle>
          <DialogDescription>Subject · {template.subject}</DialogDescription>
        </DialogHeader>
        <div className="bg-card rounded-xl border p-6">
          <SanitizedHtml html={template.body} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
